import {createApp} from 'vue'
import DirectMessagesContent from './DirectMessagesContent'

const el = '.kb-component--direct-messages-content'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((DirectMessagesContentDOM) => {
            const exturnalData = JSON.parse(DirectMessagesContentDOM.dataset.external)

            const props = {
                guid: DirectMessagesContentDOM.dataset.guid,
                chatId: exturnalData?.chatId,
                userData: exturnalData?.userData,
            }
            const component = createApp(DirectMessagesContent, props).use(Store)
            component.mount(DirectMessagesContentDOM)
        })
    }
}